/* eslint import/no-webpack-loader-syntax:0 */
// @ts-ignore
import Worker from 'comlink-loader!./worker';

export default Worker;
